// src/components/CustomButton.tsx
import React from 'react';
import { ButtonProps, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '@/stores';
import { StyledButton } from './styles/CustomButton.styles';

interface CustomButtonProps extends ButtonProps {
  children: React.ReactNode;
  loadingText?: React.ReactNode;
  useGlobalLoading?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = (props) => {
  const hasActiveRequest = useSelector(
    (state: RootState) => state.loading.activeRequests > 0,
  );
  const {
    children,
    disabled,
    loading = false,
    loadingText = 'Processing...',
    type = 'button',
    useGlobalLoading = type === 'submit',
    ...buttonProps
  } = props;
  const isLoading = Boolean(loading) || (useGlobalLoading && hasActiveRequest);

  return (
    <StyledButton
      {...buttonProps}
      aria-busy={isLoading || undefined}
      disabled={disabled || isLoading}
      type={type}
    >
      {isLoading ? (
        <>
          <CircularProgress color="inherit" size={18} thickness={5} />
          <span>{loadingText}</span>
        </>
      ) : children}
    </StyledButton>
  );
};
export default CustomButton;
